// Planned buildings on NomOS (SEN-395 / TZ-2): estimating a planned building's consumption is out of scope on NomOS and
// refuses visibly (the form asks for the estimated annual kWh instead). The energy PLAN itself is the plan_node type:
// the Targets page, and the site page's Targets tab, are Poiesis lists of it (SEN-446); the plan verbs
// (plan_set_month, plan_set_annual, plan_initialize) are served actions. No client code reads or computes a plan.
import { toAxiosError } from '../client';
import type { AnyFn, NomosRegistry } from '../registry';

const gap = (what: string) => toAxiosError(501, { detail: `${what} is not available on NomOS` }, '');

// Out of scope on NomOS: refuse visibly (never fall through to Sentinel).
const refuse = (what: string) => async () => { throw gap(what); };

export const plansImpl: NomosRegistry = {
  estimateConsumption: refuse('Estimating consumption (enter the estimated annual kWh)') as AnyFn,
};
